function LoadingScreen() {
  return (
    <main className="flex min-h-screen items-center justify-center bg-slate-100 p-6 text-slate-800">
      <p className="text-sm font-medium">Checking session...</p>
    </main>
  );
}

export default LoadingScreen;
